module.exports = __webpack_public_path__ + "static/media/cq_modifica_blu.5861487c.svg";